import { FleetProductPdpTemplate } from "~/components/products/pdp/FleetProductPdpTemplate";
import type { FleetPrices } from "~/components/products/pdp/FleetPricingSection";
import { DRIVE_FLEET_PRODUCT } from "~/data/products/drive-fleet";
import { useCurrencyPreference } from "~/lib/use-currency-preference";
import { useEmbeddedCartCatalog } from "~/lib/use-embedded-cart";

export const handle = {
  headerMode: "fleet",
  footerMode: "fleet",
  pageTheme: "fleet",
  sitemap: { title: "Bouncie Drive for Fleets" },
};

// Static until the ratings loader lands (the hero's stars + review count).
const FIXTURE_RATING = { rating: 4.8, reviewCount: 12345 };

export default function FleetProductsDrive() {
  // Prices come from the embedded cart, like the consumer HeroSection: in the visitor's
  // currency, and null (hidden) until the catalog loads. The subscription figure is the
  // base price; whether fleet should show the volume-adjusted one is still open.
  const [currency] = useCurrencyPreference();
  const { currencySymbol, unitPrice, subscriptionUnitPrice } = useEmbeddedCartCatalog(DRIVE_FLEET_PRODUCT.productCode, currency);
  const prices: FleetPrices = {
    unitPrice: unitPrice ?? null,
    subscriptionPrice: subscriptionUnitPrice ?? null,
    currencySymbol: currencySymbol ?? "",
    currencyCode: currency.toUpperCase(),
  };

  const content = { ...DRIVE_FLEET_PRODUCT, hero: { ...DRIVE_FLEET_PRODUCT.hero, ...FIXTURE_RATING } };
  return <FleetProductPdpTemplate content={content} prices={prices} />;
}
